import StudentOnlineCourseDetail from '../../features/student/StudentOnlineCourseDetail'

const StudentOnlineCourseDetailPage = () => {
  return (
    <StudentOnlineCourseDetail/>
  )
}

export default StudentOnlineCourseDetailPage